export { default as Img200 } from './processed/200/Twilight.jpg';
export { default as Img400 } from './processed/400/Twilight.jpg';
export { default as Imgthumb } from './processed/thumb/Twilight.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/Twilight.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/Twilight.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      188,
      116,
      68
    ],
    "_population": 1,
    "_hsl": [
      0.06666666666666667,
      0.4724409448818898,
      0.5019607843137255
    ]
  },
  "LightVibrant": {
    "_rgb": [
      228,
      168,
      140
    ],
    "_population": 5,
    "_hsl": [
      0.053030303030303004,
      0.6197183098591549,
      0.7215686274509805
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      68,
      28,
      28
    ],
    "_population": 1,
    "_hsl": [
      0,
      0.4166666666666667,
      0.18823529411764706
    ]
  },
  "Muted": {
    "_rgb": [
      157,
      117,
      101
    ],
    "_population": 671,
    "_hsl": [
      0.04761904761904761,
      0.22222222222222227,
      0.5058823529411764
    ]
  },
  "LightMuted": {
    "_rgb": [
      210,
      173,
      158
    ],
    "_population": 170,
    "_hsl": [
      0.0480769230769231,
      0.36619718309859145,
      0.7215686274509804
    ]
  },
  "DarkMuted": {
    "_rgb": [
      79,
      55,
      50
    ],
    "_population": 1913,
    "_hsl": [
      0.028735632183908063,
      0.22480620155038764,
      0.2529411764705882
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/Twilight.js